// pdfjs and pdf-lib are loaded on demand so they stay out of the Home bundle.

export const MAX_UPLOAD_FILES = 4;
export const MAX_PDF_TOTAL_BYTES = 5_000_000;

async function loadPdfjs() {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf");
  pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;
  return pdfjs;
}

// Renders page 1 of a PDF file to a PNG data URL. Rejects on a corrupt or
// password-protected file.
export async function getPdfThumbnail(file, width = 300) {
  const pdfjs = await loadPdfjs();
  const pdf = await pdfjs.getDocument({ data: await file.arrayBuffer() })
    .promise;

  try {
    const page = await pdf.getPage(1);
    const unscaled = page.getViewport({ scale: 1 });
    const viewport = page.getViewport({ scale: width / unscaled.width });

    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvasContext: canvas.getContext("2d"), viewport })
      .promise;

    return {
      thumbnail: canvas.toDataURL("image/png"),
      pageCount: pdf.numPages
    };
  } finally {
    pdf.destroy();
  }
}

// Merges PDF files, in order, into a single PDF's bytes.
export async function mergePdfs(files) {
  const { PDFDocument } = await import("pdf-lib");
  const merged = await PDFDocument.create();

  for (const file of files) {
    const source = await PDFDocument.load(await file.arrayBuffer());
    const pages = await merged.copyPages(source, source.getPageIndices());
    pages.forEach((page) => merged.addPage(page));
  }

  return merged.save();
}
